<script>
export default {
  name: "AddressListTable",
  props: {
    addresses: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th>登録されている通知先</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="addr in addresses" :key="addr.id">
          <td>{{ addr.email }}</td>
          <td class="text-right">
            <v-icon @click="$emit('delete', addr)">mdi-delete</v-icon>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
